var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 41,
  height: 40,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#8B4FE3",
  d: "M9.256 38.608c-.99.495-2.112-.373-1.912-1.48l2.127-11.825-9.028-8.39c-.843-.785-.405-2.22.725-2.375l12.552-1.74L19.316 1.98a1.33 1.33 0 0 1 2.376 0l5.596 10.818 12.551 1.74c1.13.155 1.568 1.59.723 2.375l-9.025 8.39 2.127 11.825c.2 1.107-.923 1.975-1.912 1.48L20.5 32.968l-11.247 5.64z"
})));
export default SvgStarFilled;